import React, { ChangeEvent, useState, useEffect } from 'react';
import { Grid, Typography, TextField, Button, InputAdornment, Avatar } from '@material-ui/core';
import { Link, useNavigate } from 'react-router-dom';
import { login } from '../../services/Service';
import UserLogin from '../../models/UserLogin';
import { Box } from '@mui/material';
import './Login.css';
import { useDispatch } from 'react-redux';
import { addToken } from '../../store/tokens/actions';
import { toast } from 'react-toastify';
import { Https, Person } from '@material-ui/icons';


function Login() {

    //Redireciona o usuário para determinada página
    let navigate = useNavigate();
    const dispatch = useDispatch();

    // Hooks que vão manipular o nosso local Storage para gravar o Token
    const [token, setToken] = useState('');

    // useStage define como uma determinada variável será inicializada quando o comp for renderizar
    const [userLogin, setUserLogin] = useState<UserLogin>(
        {
            id: 0,
            usuario: '',
            nome: '',
            foto: '',
            senha: '',
            token: ''
        }
    )

    function updatedModel(e: ChangeEvent<HTMLInputElement>) {

        setUserLogin({
            ...userLogin,
            [e.target.name]: e.target.value
        })
    }

    useEffect(() => {
        if (token !== '') {
            dispatch(addToken(token));
            navigate('/home')
        }
    }, [token])

    async function onSubmit(e: ChangeEvent<HTMLFormElement>) {
        e.preventDefault();
        try {
            await login(`/usuarios/logar`, userLogin, setToken)

            toast.success('Usuário logado com sucesso!', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                theme: "colored",
                progress: undefined,
            });
        } catch (error) {

            toast.error('Dados do usuário inconsistentes. Erro ao logar!', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                theme: "colored",
                progress: undefined,
            });

        }
    }

    return (

        <Grid container direction='row' justifyContent='center' alignItems='center' className='bg-login'>
            <Grid alignItems='center' xs={6}>
                <Box paddingX={20} className='login-esquerda'>
                    <form onSubmit={onSubmit}>
                        <Typography variant="h3" gutterBottom color='textPrimary' component="h3" align='center' className="textos1">Entrar</Typography>
                        <TextField value={userLogin.usuario} onChange={(e: ChangeEvent<HTMLInputElement>) => updatedModel(e)} id='usuario' label='usuário' variant='outlined' name='usuario' margin='normal' type="email" fullWidth InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Person className="icons" />
                                </InputAdornment>),
                        }} />
                        <TextField value={userLogin.senha} onChange={(e: ChangeEvent<HTMLInputElement>) => updatedModel(e)} id='senha' label='senha' variant='outlined' name='senha' margin='normal' type='password' fullWidth InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Https className="icons" />
                                </InputAdornment>),
                        }} />

                        <Box marginTop={2} textAlign='center' className='card-login'>
                            <Button type='submit' variant='contained' color='primary' className='botao'>
                                Logar
                            </Button>
                        </Box>
                    </form>
                    <Box display='flex' justifyContent='center' marginTop={2}>
                        <Box marginRight={1}>
                            <Typography variant='subtitle1' gutterBottom align='center'>Não tem uma conta?</Typography>
                        </Box>
                        <Link to='/cadastrousuario' className="textos2">
                            <Typography variant='subtitle1' gutterBottom align='center' style=
                                {{ fontWeight: 'bold', cursor: "pointer" }}>Cadastre-se</Typography>
                        </Link>

                    </Box>
                </Box>

            </Grid>
            <Grid xs={6} className="imagem">

            </Grid>
        </Grid>
    );

}

export default Login;